module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar nav-menu"
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("Menu")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  })]), _vm._v(" Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  })]), _vm._v(" Products")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-mobile"
  })]), _vm._v(" Applications")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" Users")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "is-hidden-desktop"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "menu-label"
  }, [_vm._m(0), _vm._v("\n      " + _vm._s(this.$store.state.customer.name) + "\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(1), _vm._v("Log out")])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-user-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-sign-out"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-bottom has-text-centered has-text-grey"
  }, [_c('p', {
    staticClass: "is-size-7"
  }, [_vm._v("IoT Console")]), _vm._v(" "), _c('p', {
    staticClass: "is-size-7"
  }, [_vm._v("by "), _c('a', {
    attrs: {
      "href": "https://fusionnextinc.com/"
    }
  }, [_vm._v("Fusion Next Inc.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62857a78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Sidebar.vue
// module id = 215
// module chunks = 1